var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',_vm._g({attrs:{"xmlns":"http://www.w3.org/2000/svg","width":"16","height":"6","viewBox":"0 0 16 6"}},_vm.$listeners),[_c('path',{attrs:{"d":"M16 2H0V0h16v2zm0 2H0v2h16V4z"}})])}
var staticRenderFns = []

export { render, staticRenderFns }